import { useTranslation } from 'tools/i18n';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    stock: {
        color: 'inherit',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: '15px',
        fontWeight: 300,
        letterSpacing: 0,
        lineHeight: 1,
        marginBottom: 2,
        fontSmoothing: 'auto',
        '&.indicator': {
            '&:before': {
                content: '""',
                height: '5px',
                width: '5px',
                borderRadius: '50%',
            },
            '&.in-stock:before': {
                backgroundColor: 'green',
            },
            '&.black:before': {
                backgroundColor: 'black',
            },
            '&.out-of-stock:before': {
                backgroundColor: 'red',
            },
        }
    },
}), { name: 'StockIndicator' });

/**
 * @typedef {Object} StockIndicatorProps
 * @property {boolean} [show=true]
 * @property {number|null} [stock]
 * @property {ShopwareProduct.deliveryTime|null} [deliveryTime]
 * @property {object|null} [style]
 * @property {string|null} [className]
 */

/**
 * @param {StockIndicatorProps} props
 * @returns {JSX.Element}
 */
export default function StockIndicator(
    {
        show = true,
        stock,
        deliveryTime,
        style = null,
        className = null,
        mode = null
    },
) {
    const classes = useStyles();
    const classNames = `${classes.stock} ${className}`;
    const { t } = useTranslation();

    if (!show) {
        return null;
    }

    function resolveIndicator(deliveryTime) {
        if (['5ae66ca4e2124856b52e872650f1de21', '0195c85ea5127750b0a744f019b4bd6d'].includes(deliveryTime?.id)) {
            return 'in-stock';
        }

        if (['45a286a87e28491b8c4802d0b395712d', '45a286a87e28491b8c4802d0b395712d'].includes(deliveryTime?.id)) {
            return 'out-of-stock';
        }

        if (deliveryTime?.unit === 'day') {
            return 'in-stock'
        }

        if (deliveryTime?.unit === 'week' || deliveryTime?.unit === 'year') {
            return 'black'
        }

        if (!deliveryTime?.id) {
            return null
        }

        return 'black';
    }

    if (deliveryTime) {
        let indicator = resolveIndicator(deliveryTime);
        let displayName = deliveryTime?.translated?.name || deliveryTime?.name

        return (
            <span style={style} className={`${classNames} ${indicator} ${indicator ? 'indicator' : ''}`}>
                {displayName}
            </span>
        );
    }

    if (!stock) {
        return <span></span>;
    }

    return <>
        <span style={style} className={classNames}>
        </span>
    </>;
}
